import { createContext } from 'react';
import {
  OFFER_SHIFT_STATUS,
  type OfferCardOfferShift,
  type OfferShiftForAcceptance,
  type ProposedOfferShift,
} from './offer-card-v3/offer-card-types';

export const filterShiftsByInventoryIds = (inventoryIds: string[], shiftMap: Map<string, OfferCardOfferShift[]>): ProposedOfferShift[] => {
  const filteredShifts: ProposedOfferShift[] = [];
  inventoryIds.forEach((id) => {
    const matchingShifts = shiftMap.get(id);
    matchingShifts?.forEach((shift) => {
      if (shift.status === OFFER_SHIFT_STATUS.PROPOSED) filteredShifts.push(shift);
    });
  });
  return filteredShifts;
};

export const formatShiftsForAcceptance = (shifts: ProposedOfferShift[]): OfferShiftForAcceptance[] => {
  const offerShifts = shifts.reduce((shiftArgs, shift) => {
    if (!shiftArgs.has(shift.buyerSiteId)) {
      shiftArgs.set(shift.buyerSiteId, {
        buyerSiteName: shift.buyerSite.siteName,
        shiftedOfferListings: [],
      });
    }
    shiftArgs.get(shift.buyerSiteId)?.shiftedOfferListings.push({
      id: shift._id,
      shiftedInventoryId: shift.shiftInventoryId,
      pricePerCase: shift.unitPrice,
      shiftedQuantity: shift.shiftedQuantity,
      logisticsOption: shift.newLogisticsRelationshipName,
      shiftType: shift.shiftType,
      originalOfferId: shift.originalOfferListingId,
    });
    return shiftArgs;
  }, new Map<string, OfferShiftForAcceptance>());
  return [...offerShifts.values()];
};

const OfferShiftContext = createContext<{
  shiftMap: Map<string, OfferCardOfferShift[]>;
  offerShiftsMappedToTrucklanes: Map<string, OfferCardOfferShift[]>;
  currentShifts: OfferCardOfferShift[];
  setCurrentShifts: (shifts: OfferCardOfferShift[], inventoryId?: string) => void;
} | null>(null);

export default OfferShiftContext;
